<div class="dialog-main">
  <div class="header mt-3">
    <h2 class="modal-title text-center heading2 mb-0">
      <b>
        {{ title }}
      </b>
      <button
        *ngIf="crossIcon"
        type="button"
        class="close"
        (click)="rejectDialog()"
      >
        <span> <img src="/assets/svg/ico-cross.svg" /> </span>
      </button>
    </h2>
  </div>
  <div class="rounded-top d-flex justify-content-center align-items-center">
    <div class="body-text mx-2">
      <ng-container *ngIf="headingText">
        <h1>
          <b>{{ headingText }}</b>
        </h1>
      </ng-container>

      <ng-container *ngIf="bodyText">
        <br />
        <p class="text">
          {{ bodyText }}
        </p>
      </ng-container>

      <ng-container *ngIf="footerText">
        <br />
        <p class="text">
          {{ footerText }}
        </p>
      </ng-container>
    </div>
  </div>

  <div class="row my-2">
    <div class="col-12 my-1 text-center">
      <button
        class="btn btn-danger px-3 done-btn"
        type="button"
        (click)="acceptDialog()"
      >
        {{ btnOk }}
      </button>
    </div>
  </div>
</div>
